<div class="dialog dialog-error">
  <h1 i18n mat-dialog-title>Notice</h1>
  <div id="dialog-content" mat-dialog-content>
    <p i18n class="font-size-large">
      Your request cannot be created/cancelled at this time, for assistance please contact us at
    </p>
  </div>
  <div *ngIf="!data.params.hideActions" mat-dialog-actions>
    <app-call-aaa-button
      [clickEventPage]="pageType"
      (buttonClick)="onCallAAAClick()"
      >
    </app-call-aaa-button>
    <button
      i18n
      i18n-aria-label
      *ngIf="!!data.params.showDismissButton"
      id="dialog-dismiss-submit"
      name="dialogGenericErrorDismiss"
      class="btn primary btn-sm"
      aria-label="dismiss this message"
      (click)="onClose()"
    >
      Dismiss
    </button>
  </div>
  <button i18n-aria-label mat-dialog-close class="mat-dialog-close" aria-label="dismiss this message">
    <icon-close></icon-close>
  </button>
</div>
